<template>
  <modal-dialog :name="modalName" :width="modalWidth" :height="modalHeigth" @closed="clearSelect">
    <div class="modal-dialog paragraph">
      <upload-cv-option-illustration></upload-cv-option-illustration>
      <h3 class="heading-3">{{ labels.uploadCv }}</h3>
      <radio-choices
        :choices="uploadTypes"
        :initialValue="selectedUploadType"
        @change-choice="changeUploadResumeType"
      ></radio-choices>
      <p class="paragraph-s warning-undo-action" v-html="labels.warningUndoAction"></p>
      <cv-file-upload
        :showTitle="false"
        :files="resumeState.files"
        :error="resumeState.errors"
        @on-file-attach="handleUploadResume"
      >
        <div slot="attachment-field" class="buttons" slot-scope="props">
          <div v-if="resumeState.loading" class="button is-secondary paragraph-m is-rounded">
            <div class="loader"></div>
          </div>
          <div v-else>
            <b-upload :accept="props.acceptedFileTypes" @input="props.changeAttachmentsField">
              <a v-translate class="button is-secondary paragraph-m is-rounded">
                Continue
              </a>
            </b-upload>
          </div>
        </div>
      </cv-file-upload>
    </div>
  </modal-dialog>
</template>

<script>

import ModalDialog from 'top20common/components/ModalDialog';
import CvFileUpload from 'top20common/components/file-upload/CvFileUpload';
import RadioChoices from 'top20common/components/form/RadioChoices';
import UploadCvOptionIllustration from 'top20common/components/illustrations/UploadCvOptionIllustration';
import {mapGetters} from 'vuex';

const REPLACE = 'replace';
const REPLACE_AND_UPDATE = 'replace-and-update';

export default {
  props: {
    modalName: String,
    replaceMode: {type: Boolean, default: true}
  },
  data() {
    return {
      selectedUploadType: REPLACE,
      replace: REPLACE,
      replaceAndUpdate: REPLACE_AND_UPDATE
    };
  },
  computed: {
    ...mapGetters(['resumeState']),
    labels() {
      return {
        uploadCv: this.$gettext('Upload CV'),
        replaceCvText: this.$gettext('Replace my current CV on file only'),
        replaceCvAndUpdateProfileText: this.$gettext(
          'Replace my current CV on file, and overwrite my profile with the content from the new CV'
        ),
        uploadCvText: this.$gettext('Upload the CV only'),
        uploadCvAndUpdateProfileText: this.$gettext(
          'Upload the CV, and overwrite my profile with the content from this CV'
        ),
        warningUndoAction: this.$gettextInterpolate(
          this.$gettext(
            '<span class="paragraph-secondary">Warning: </span><span class="paragraph-dark-gray">you cannot undo this action.</span>'
          ),
          {}
        ),
        cvProfileUpdated: this.$gettext('CV and profile updated'),
        cvUploaded: this.$gettext('CV uploaded')
      };
    },
    uploadTypes() {
      return {
        [REPLACE]: this.replaceMode ? this.labels.replaceCvText : this.labels.uploadCvText,
        [REPLACE_AND_UPDATE]: this.replaceMode
          ? this.labels.replaceCvAndUpdateProfileText
          : this.labels.uploadCvAndUpdateProfileText
      };
    },
    modalWidth() {
      return this.$mq.phone ? '300px' : '414px';
    },
    modalHeigth() {
      return this.$mq.phone ? '500px' : '520px';
    }
  },
  methods: {
    changeUploadResumeType(newValue) {
      this.selectedUploadType = newValue;
    },
    handleUploadResume(file) {
      let parse = this.selectedUploadType === REPLACE_AND_UPDATE;
      this.$store
        .dispatch('uploadCandidateResumeAction', {file, parse})
        .then(() => {
          this.$modal.hide(this.modalName);
          if (parse) {
            this.$store.dispatch('getProfileAction').then(() => {
              this.$router.push({name: 'edit-basic-profile-data'});
              this.$toast.open({message: this.labels.cvProfileUpdated, type: 'is-success', duration: 3000});
            });
          } else {
            this.$store.commit('mutateProfileDetailsFieldState', {field: 'resume_file_name', value: file[0].name});
            this.$toast.open({message: this.labels.cvUploaded, type: 'is-success', duration: 3000});
          }
        })
        .catch(() => {
          this.$modal.hide(this.modalName);
          this.$store.commit('mutateProfileDetailsFieldState', {field: 'resume_file_name', value: file[0].name});
          this.showErrorToast();
        });
    },
    showErrorToast() {
      this.$toast.open({
        message: this.$gettext(
          "Our system couldn't read your CV file, but it's saved in case you want to keep it as an attachment."
        ),
        type: 'is-danger'
      });
    },
    clearSelect() {
      this.selectedUploadType = REPLACE;
    }
  },
  components: {
    ModalDialog,
    UploadCvOptionIllustration,
    RadioChoices,
    CvFileUpload
  }
};
</script>


<style lang="scss" scoped>
@import '~VariablesStyles';
.modal-dialog {
  display: flex;
  flex-direction: column;
  padding: 25px 20px;

  svg {
    position: relative;
    top: -25px;
    left: -20px;
    @media (max-width: $tablet) {
      width: calc(100% + 40px);
      height: auto;
    }
  }

  h3 {
    padding-bottom: 25px;
  }

  /deep/ .choices:not(:last-child) {
    padding-bottom: 20px;
  }

  /deep/ .check {
    min-width: 1.25em;
  }

  /deep/ .choices label {
    align-items: flex-start;
  }

  .warning-undo-action {
    padding: 5px 0 0 26px;
  }

  .buttons {
    margin-top: 15px;
    .button {
      min-width: 122px;
    }
  }
}
</style>
